import * as XLSX from 'xlsx';

/**********************
    Beispiele siehe unten
**********************/
export function setColStyle(sheetData: XLSX.WorkSheet, style: any, col: number) {
    const rows = XLSX.utils.decode_range(sheetData['!ref']).e.r;
    const start = { c: col, r: 0 } as XLSX.CellAddress;
    const end = { c: col, r: rows } as XLSX.CellAddress;
    applyStyleToRange(sheetData, { s: start, e: end } as XLSX.Range, style);
}

export function setRowStyle(sheetData: XLSX.WorkSheet, style: any, row: number) {
    const cols = XLSX.utils.decode_range(sheetData['!ref']).e.c;
    const start = { c: 0, r: row } as XLSX.CellAddress;
    const end = { c: cols, r: row } as XLSX.CellAddress;
    applyStyleToRange(sheetData, { s: start, e: end } as XLSX.Range, style);
}

export function setCellStyleByClassname(sheetData: XLSX.WorkSheet, style: any, classname: string) {
    const rows = XLSX.utils.decode_range(sheetData['!ref']).e.r;
    const cols = XLSX.utils.decode_range(sheetData['!ref']).e.c;
    const start = { c: 0, r: 0 } as XLSX.CellAddress;
    const end = { c: cols, r: rows } as XLSX.CellAddress;
    applyStyleToRange(sheetData, { s: start, e: end } as XLSX.Range, style, classname);
}

export function setSheetStyle(sheetData: XLSX.WorkSheet, style: {}): void {
    const rows = XLSX.utils.decode_range(sheetData['!ref']).e.r;
    const cols = XLSX.utils.decode_range(sheetData['!ref']).e.c;
    const start = { c: 0, r: 0 } as XLSX.CellAddress;
    const end = { c: cols, r: rows } as XLSX.CellAddress;
    applyStyleToRange(sheetData, { s: start, e: end }, style);
}

function applyStyleToRange(sheetData: XLSX.WorkSheet, range: XLSX.Range, style: any, classname?: string): void {
    for (let r = range.s.r; r <= range.e.r; ++r) {
        for (let c = range.s.c; c <= range.e.c; ++c) {
            applyStyleToCell(sheetData, c, r, style, classname);
        }
    }
}

function applyStyleToCell(sheetData: XLSX.WorkSheet, col: number, row: number, style: any, classname?: string): void {
    const cell = sheetData[encodeCell(col, row)];
    const newStyle = JSON.parse(JSON.stringify(style));
    if (cell) {
        if (classname && (cell.classname === undefined || cell.classname !== classname)) {
            return;
        }
        if (cell.s) {
            Object.assign(cell.s, newStyle);
        } else {
            try {
                cell.s = newStyle;
            } catch (e) {
                // console.log('applyStyleToCell', row, col, e);
            }
        }
    }
}
function encodeCell(col: number, row: number): string {
    return XLSX.utils.encode_cell({ c: col, r: row });
}
// z.B. so für hellen Hintergrund und dunklen Vorfergrund : ('FFDDDDDD', 'FF000000')

export function generateFillColorStyle(backgroundColor: string): any {
    return {
        fill: { patternType: 'solid', fgColor: { rgb: backgroundColor } }
    };
}

/*
BEISPIELE für Styles
        const font20bold = { font: { sz: '20', bold: true, name: 'Arial'}};
        const font10 = { font: { sz: '10', bold: false, name: 'Arial' }};
        const font12 = { font: { sz: '12', bold: false, name: 'Arial' }};
        const font1 = { font: { sz: '1', bold: false, name: 'Arial' }};
        const font12bold = { font: { sz: '12', bold: true, name: 'Arial' }};
        const font16bold = { font: { sz: 16, bold: true, name: 'Arial' }};
        const alignCenter = { alignment: {horizontal: 'center'}};
        const alignCenterHV = { alignment: {horizontal: 'center', vertical: 'center'}};

        const alignLeft = { alignment: {horizontal: 'left'}};
        const alignLeftM = { alignment: {horizontal: 'left', vertical: 'center'}};
        const alignRight = { alignment: {horizontal: 'right'}};
        const alignRightM = { alignment: {horizontal: 'right', vertical: 'center'}};
        const borderAllThin = {border: {bottom: {style: 'thin'}, left: {style: 'thin'}, right: {style: 'thin'},  top: {style: 'thin'}}};
        const borderAllMedium = {border: {bottom: {style: 'medium'}, left: {style: 'medium'},
                                 right: {style: 'medium'},  top: {style: 'medium'}}};
        const borderBotMedium = {border: {bottom: {style: 'medium'}}};

*/
